import { useState } from 'react';
import { useSelector } from 'react-redux';
import i18n from '../../../i18n';
import { ScriptService } from '../../../controllers/ScriptService';
import './style.scss';
import { isBossIdSameAsLocation } from '../../../utils/appUtils';
import { ApiAuthResponse, RootState, SubnetIds } from '../../../interfaces';
import dkFlag from '../../../images/dk.png';
import noFlag from '../../../images/no.png';
import TopMenu from './TopMenu';

import './style.scss';

interface StickyHeaderProps {
  overPlayer?: boolean;
}

export default function StickyHeader({ overPlayer }: StickyHeaderProps) {
  const [showOptimizedMessage, setShowOptimizedMessage] = useState<boolean>(true);
  const auth = useSelector((root: RootState) => root.authReducer.auth as ApiAuthResponse);
  const isGuest = useSelector((root: RootState) => root.authReducer.isGuest);

  const showNotOptimised = !ScriptService.isOptimizedForWeb() && showOptimizedMessage;
  const stickyHeaderClass = 'stickyheader sticky' + (ScriptService._isIE() ? ' IE' : '');

  function setGuestCountry(subnetId: number) {
    ScriptService.setStoredGuestLocation(`${subnetId}`);
    window.location.reload();
  }

  function shouldShowCountrySelector() {
    const showCountrySelector = ScriptService.isNETDomain() && isGuest && isBossIdSameAsLocation(auth);
    const guestLocation = ScriptService.getStoredGuestLocation();

    if (showCountrySelector && guestLocation && guestLocation === SubnetIds.NO) {
      return false;
    }

    return showCountrySelector;
  }

  return (
    <>
      {overPlayer ? null : <div className="sticky-buffer" />}
      <div className={stickyHeaderClass}>
        <TopMenu />

        {shouldShowCountrySelector() ? (
          <div className={'country-selector' + (showNotOptimised ? ' move-down' : '')}>
            <p className="body">
              {i18n.t<string>('see content for')}
              <span
                className="flag"
                onClick={() => {
                  setGuestCountry(SubnetIds.DK);
                }}
              >
                <img src={dkFlag} alt="DK" />
              </span>
              <span
                className="flag"
                onClick={() => {
                  setGuestCountry(SubnetIds.NO);
                }}
              >
                <img src={noFlag} alt="NO" />
              </span>
            </p>
          </div>
        ) : null}

        {showNotOptimised ? (
          <div className="not-optimized-container">
            <p className="body">{i18n.t<string>('webpage not optimized')}</p>
            <div onClick={() => setShowOptimizedMessage(!showOptimizedMessage)} className="aib-icon close-optimize">
              B
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
